(function () {
  document.querySelectorAll('.primo-btn').forEach(function (button) {
    button.addEventListener('mousedown', function () {
      button.classList.add('is-pressed');
    });
    ['mouseup', 'mouseleave'].forEach(function (evt) {
      button.addEventListener(evt, function () {
        button.classList.remove('is-pressed');
      });
    });
  });

  var nav = document.getElementById('primo-rf-nav');
  var hero = document.getElementById('primo-rf-hero');

  if (nav) {
    function updateNav() {
      var pastHero = hero && window.scrollY > hero.offsetHeight - 100;
      var scrolled = window.scrollY > 48;
      nav.classList.toggle('is-scrolled', window.scrollY > 8);
      nav.classList.toggle('is-solid', scrolled || pastHero);
    }

    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = anchor.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('.primo-faq__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));

      document.querySelectorAll('.primo-faq__trigger').forEach(function (other) {
        if (other === trigger) return;
        other.setAttribute('aria-expanded', 'false');
        var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
        if (otherPanel) otherPanel.hidden = true;
      });

      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  var stickyCta = document.getElementById('primo-sticky-cta');
  var bookingSection = document.getElementById('primo-rf-booking');

  if (stickyCta && bookingSection && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('is-hidden', entry.isIntersecting);
        });
      },
      { root: null, threshold: 0.15 }
    );
    stickyObserver.observe(bookingSection);
  }

  function markIconsReady() {
    document.documentElement.classList.add('primo-icons-ready');
  }

  if (document.fonts && document.fonts.load) {
    document.fonts
      .load('24px "Material Symbols Outlined"')
      .then(markIconsReady)
      .catch(markIconsReady);
    setTimeout(markIconsReady, 2500);
  } else {
    markIconsReady();
  }
})();


document.addEventListener('DOMContentLoaded', () => {
  const trackingParams = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'utm_keyword',
    'keyword',
    'fbclid',
    'msclkid',
    'ttclid',
    'li_fat_id',
    'gad_source'
  ];

  const currentUrl = new URL(window.location.href);

  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');

    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    const url = new URL(href, window.location.origin);

    // Skip external domains
    if (url.origin !== window.location.origin) return;

    trackingParams.forEach(param => {
      const value = currentUrl.searchParams.get(param);
      if (value && !url.searchParams.has(param)) {
        url.searchParams.set(param, value);
      }
    });

    link.href = url.pathname + url.search + url.hash;
  });
});

